<template>
  <div v-if="board" class="founders-base bg-bg-4">
    <header class="founder-header bg-bg-4">
      <div
        class="container flex-middle flex-center min-height-parent text-center"
        style="height: 100%">
        <h1
          class="margin-remove text-center c-text flex flex-middle  line-height-080"
          style="line-height: 0.8;">
          <div class="title-content flex-column  flex-middle">
            <span class="block main-title-text line-height-080 margin-remove">{{ board?.displayName }}</span>
            <span
              v-if="hasAboutContent"
              class="block text-l bold underline text-m cursor-pointer"
              @click="showingBoardAbout = true">
              {{ t("ls.founderBoard.readAboutCta") }}
            </span>
          </div>
        </h1>
      </div>
    </header>
    <div class="header-spacer"></div>
    <main class="main-content">
      <div class="main-inner relative flex-between">
        <div
          class="sidebar container relative margin-remove padding-2xl-top padding-s-bottom"
          :class="{ active: isSidebarActive }">
          <slot name="sidebar"></slot>
          <div
            class="sidebar-trigger l:hidden"
            @click="isSidebarActive = !isSidebarActive">
            <icon-halo
              v-if="!isSidebarActive"
              class="animate__pulse animate--faster"
              halo-theme="lead"
              theme="bg"
              icon="magnify"
              :size="2" />
            <icon-halo
              v-if="isSidebarActive"
              class="animate__pulse animate--faster"
              halo-theme="lead"
              theme="bg"
              icon="x"
              :size="2" />
          </div>
        </div>
        <div
          class="main-content-inner container container--expand width-expand margin-remove padding-xl-top padding-2xl-bottom">
          <slot name="default"></slot>
        </div>
      </div>
    </main>
    <footer class="founder-footer">
      <div
        class="footer-inner gap-m relative flex fap-max flex-middle flex-wrap flex-between padding-s-vertical padding-l-horizontal">
        <div class="site-logo flex flex-middle gap-m">
          <div class="flex-column">
            <div class="flex gap-m">
              <a
                href="https://localtimeline.com"
                target="_black"
                class="flex flex-middle flex-start max-size-parent object-contain">
                <img
                  class="max-size-parent object-contain"
                  :src="getDynamicAssetUrl('images/ls/founder-footer-logo.png')" />
              </a>
              <div class="text-ui flex-middle  gap-s" style="">
                <a
                  v-if="$store.getters['user/isLoggedIn']"
                  class=""
                  href="#"
                  @click.prevent="logOut">
                  {{ t("ls.founderBoard.logoutCta") }}
                </a>
                <a
                  v-if="!$store.getters['user/isLoggedIn']"
                  href="#"
                  class=""
                  @click.prevent="showLogin">
                  {{ t("ls.founderBoard.loginCta") }}
                </a>
              </div>
            </div>

            <span class="text-xs">
              {{ tu("ls.founderBoard.lsCredits") }}
            </span>
          </div>
        </div>
        <div class="footer-tagline">
          <h2 class="h1 c-text margin-remove">
            {{ board?.footerTagLine }}
          </h2>
        </div>
        <div
          v-if="board.logos"
          class="footer-links flex flex-middle gap-l flex-wrap">
          <div v-for="logo of board?.logos" class="link">
            <a
              v-if="logo.link && logo.link != ''"
              :href="logo.link"
              target="_blank">
              <img :src="logo.image" v-if="logo.image && logo.image.length>0" :alt="logo.alt" />
              <span class="underline" v-else>{{logo.alt}}</span>
            </a>
            <span v-else>
              <img :src="logo.image" :alt="logo.alt" />
            </span>
          </div>
        </div>
      </div>

      <modal
        :show="isLoggingIn"
        :show-footer="false"
        :show-header="false"
        @modal:closed="isLoggingIn = false">
        <div class="container flex-middle flex-center">
          <login :login-redirect="false" @login:success="handleLoginSuccess">
            <template #footer-links>
              <span style="display: none"></span>
            </template>
          </login>
        </div>
      </modal>

      <modal
        size="l"
        :show="showingBoardAbout"
        :show-footer="true"
        :show-header="true"
        title="ls.founderBoard.readAboutTitle"
        @modal:closed="showingBoardAbout = false">
        <template #title-text>
          <span>{{
            tu("ls.founderBoard.readAboutTitle", {
              boardName: board.displayName,
            })
          }}</span>
        </template>
        <template #default>
          <div v-if="board" class="container">
            <content-blocks :content="board.aboutContent" />
          </div>
        </template>
        <template #footer>
          <form-button
            theme="inverse"
            text="ls.founderBoard.closeAboutCta"
            icon="x"
            @click="showingBoardAbout = false"></form-button>
        </template>
      </modal>
    </footer>
  </div>
</template>

<script>
import Login from "@/client/views/Login.vue";
import { hasProperty } from "../../../utilities";

export default {
  components: {
    Login,
  },
  props: {
    board: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data: function () {
    return {
      showingBoardAbout: false,
      isLoggingIn: false,
      isSidebarActive: false,
    };
  },
  computed: {
    hasAboutContent() {

      if (!this.board || !this.board.aboutContent) {
        return false;
      }

      if (!utilities.hasProperty(this.board.aboutContent, "blocks")) {
        return false;
      }
      if (!Array.isArray(this.board.aboutContent.blocks)) {
        return false;
      }

      return this.board.aboutContent.blocks.length > 0;
    },
  },
  mounted() {

  },
  methods: {
    showLogin() {
      this.isLoggingIn = true;
    },
    handleLoginSuccess() {
      this.isLoggingIn = false;
    },
    async logOut() {
      await this.$store.dispatch("user/logout");
      this.$s.ui.notification("ls.user.logoutSuccessful", "success");
    },
  },
};
</script>

<style scoped lang="scss"></style>
<style lang="scss">
.founders-base {
  position: relative;
  min-height: 100lvh;
  //height: 100vh;
  height: auto;
  --lsf-header-height: calc(var(--base-margin) * 80);
  --lsf-footer-height: calc(var(--base-margin) * 74);
  --lsf-header-and-footer-height: calc(
    var(--lsf-header-height) + var(--lsf-footer-height) + 2px
  );

  .founder-header {
    position: fixed;
    top: 0;
    inset-inline-start: 0;
    width: 100%;
    height: var(--lsf-header-height);
    box-shadow: var(--box-shadow-2);
    z-index: var(--z-3);
    border-bottom: 2px solid var(--c-bg-5);

    h1 {
      display: inline-block;
      font-size: calc(var(--font-max) * 1.15);
      text-overflow: ellipsis;
      overflow: hidden;
      white-space: nowrap;

      @media screen and (max-width: 1024px) {
        font-size: calc(var(--font-max) * 0.8);
      }
    }

    .main-title-text {
      line-height: 0.8;

      @media screen and (max-width: 1024px) {
        max-width:100%;
        display: block;
        font-size: calc(var(--font-max) * 0.8);
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }

      @media screen and (max-width: 767px) {
        font-size: calc(var(--font-max) * 0.6);
        white-space:wrap;
        line-height: 1;

        display: -webkit-box;
        -webkit-line-clamp: 2; /* number of lines to show */
        line-clamp: 2;
        -webkit-box-orient: vertical;
      }

      @media screen and (max-width: 360px) {
        font-size: calc(var(--font-max) * 0.6);
      }
    }
  }

  .header-spacer {
    width: 100%;
    height: var(--lsf-header-height);
  }

  .main-content {
    $main-content-height-fallback: calc(
      100vh - var(--lsf-header-and-footer-height)
    );
    $main-content-height: calc(100lvh - var(--lsf-header-and-footer-height));
    min-height: $main-content-height;
    height: $main-content-height-fallback;
    height: $main-content-height;
    position: relative;
    z-index: var(--z-1);
    background-color: var(--c-bg);
  }

  .main-inner {
    position: relative;
    $main-content-height-fallback: calc(
      100vh - var(--lsf-header-and-footer-height)
    );
    $main-content-height: calc(100lvh - var(--lsf-header-and-footer-height));
    min-height: $main-content-height;
    height: $main-content-height-fallback;
    height: $main-content-height;
    z-index: var(--z-1);
  }

  .main-content-inner {
    position: relative;
    $main-content-height-fallback: calc(
      100vh - var(--lsf-header-and-footer-height)
    );
    $main-content-height: calc(100lvh - var(--lsf-header-and-footer-height));
    min-height: $main-content-height;
    height: $main-content-height-fallback;
    height: $main-content-height;
    max-height: $main-content-height-fallback;
    max-height: $main-content-height;
    overflow-y: auto;
    z-index: var(--z-1);
    scrollbar-color: var(--c-lead-2) var(--c-gray);
    scrollbar-width: auto;
    width: calc(var(--base-margin) * 1200);


    &::-webkit-scrollbar {
      width: calc(var(--margin-m) * 1.3);
    }
  }

  .founder-footer {
    background-color: var(--c-gray-1);
    min-height: var(--lsf-footer-height);
    position: relative;
    z-index: var(--z-2);
    box-shadow: var(--box-shadow-5);
    border-top: 2px solid var(--c-bg-5);
    overflow: visible;

    @media screen and (max-width: 767px) {
      text-align: center;
    }

    .footer-inner {
      @media screen and (max-width: 767px) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: var(--margin-l);
      }
    }

    .site-logo {
      max-width: calc(var(--base-margin) * 300px);
      flex: 0 0 auto;
      width: auto;
      height: auto;
      display: flex;
      justify-content: center;
      align-items: center;

      @media screen and (max-width: 767px) {
        flex: auto;
        flex-direction: column;

        width: calc(var(--base-margin) * 80);
      }

      img {
        object-fit: contain;
        max-width: calc(var(--base-margin) * 80);
      }
    }

    .text-ui {
      a {
        text-decoration: underline;
      }
    }

    .container {
    }

    .footer-tagline {

      @media (min-width: 1024px) {
        // 100% - footer margins - size of other elements
        max-width: calc(100% - 2 * (var(--margin-m) - var(--base-margin) * 700));
        position: absolute;
        inset-inline-start: 50%;
        transform: translateX(50%);
      }
    }

    .footer-links {
      max-width: calc(var(--base-margin) * 400);
      display: flex;
      align-items: center;
      gap: var(--margin-l);
      @media screen and (max-width: 767px) {
        display: flex;
        justify-content: center;
        align-items: center;
        gap: var(--margin-l);
      }

      .link {
        max-height: calc(var(--base-margin) * 48);
      }

      a,
      span {
        display: inline-block;
      }

      img {
        max-height: calc(var(--base-margin) * 48);
        max-width: calc(var(--base-margin) * 100);
      }
    }
  }

  // whwen built, this is required due to specificity/order issue
  .sidebar,
  .sidebar.container {
    background-color: var(--c-bg-4);
    flex: 0 0 calc(var(--base-margin) * 340) !important;
    max-width:calc(var(--base-margin) * 340) !important;
   // max-width: calc(100vw - (var(--base-margin) * 30));
    //max-width: calc(100lvw - (var(--base-margin) * 30));
    border-inline-end: 2px solid var(--c-bg-5);
    height: calc(100lvh - var(--lsf-header-and-footer-height));
    max-height: calc(100vh - var(--lsf-header-and-footer-height));
    max-height: calc(100lvh - var(--lsf-header-and-footer-height));
    position: relative;

    @media (max-width: 500px) {
      flex: 0 0 calc(var(--base-margin) * 320) !important;

      &:not(.active) {
        max-width: calc(var(--base-margin) * 250);
      }
    }

    @media (max-width: 1024px) {
      position: absolute;
      top: 0;
      inset-inline-start: 0;
      height: 100%;
      z-index: var(--z-3);
      transition: transform 200ms ease,background-color 200ms ease;
      transform: translateX(calc(100% - (var(--base-margin) * 35)));

      &:not(.active) {
        padding-inline-end: calc(var(--base-margin) * 40) !important;
        background-color: transparent;
        border-inline-end:none;
      }
      &.active {
        transform: none;
        background-color: var(--c-bg-4);
        border-inline-end: 2px solid var(--c-bg-5);
      }
    }
  }

  .sidebar-trigger {
    position: absolute;
    top: 50%;
    inset-inline-end: 0;
    transform: translateY(-50%) translateX(-50%);
    display: inline-block;
    border-radius: 50%;
    border: 2px solid var(--c-bg-5);
    cursor: pointer;

    [dir="ltr"] & {
      transform: translateY(-50%) translateX(50%);
    }
  }

  .sidebar.active .sidebar-trigger {
    transform: translateY(-50%) translateX(-50%);

    [dir="ltr"] & {
      transform: translateY(-50%) translateX(50%);
    }
  }

  .main-inner {
    overflow-x: hidden;
  }
}
</style>
